<script>
import fbPixel from '@/utils/fbPixel';
import { mapGetters } from 'vuex';

export default {
  name: 'PaymentStatus',
  props: {
    app: {
      type: String,
      default: 'MPCInvoice'
    }
  },
  data() {
    return {
      paymentInfo: null,
      isLoading: true,
      limitRequest: 0,
      wasSentFsStatus: false

    };
  },
  computed: {
    ...mapGetters(['country'])
  },
  created() {
    this.wasSentFsStatus = false;
    this.getPaymentInfo();
  },
  methods: {
    getPaymentInfo() {
      this.limitRequest++;
      global.api.paymentStatus(this.$route.params.folio, this.app).then((res) => {
        if (res.data.invoiceOrderStatus === 'Processing') {
          if (this.limitRequest < 6) {
            setTimeout(() => {
              this.getPaymentInfo();
            }, 5000);
          } else {
            this.sendStatusToFs(false);
            this.$emit('hasError', 'IS_PROCESSING');
          }
        } else if (res.data.invoiceOrderStatus === 'Successful') {
          fbPixel(this.country.pais);
          this.paymentInfo = res.data;
          this.$emit('paymentInfo', this.paymentInfo);
          this.isLoading = false;
          // eslint-disable-next-line no-undef
          // dataLayer.push({'postPurchase':'true'})
          window.postPurchase = true;
          this.sendStatusToFs(true);
          // eslint-disable-next-line no-undef
          if (typeof KAMPYLE_ONSITE_SDK !== 'undefined' && typeof KAMPYLE_ONSITE_SDK.updatePageView === 'function') {
            // eslint-disable-next-line no-undef
            KAMPYLE_ONSITE_SDK.updatePageView();
          }
        } else {
          this.isLoading = false;
          this.paymentInfo = res.data;

          this.$emit('paymentInfo', this.paymentInfo);
          this.sendStatusToFs(false);
          this.sendOrderStatusToFs(res.data.invoiceOrderStatus);
          this.$emit('hasError', res.data.invoiceOrderStatus.toUpperCase());
        }
      }).catch((err) => {
        this.sendStatusToFs(false);
        this.sendErrorToFs(err);
        this.isLoading = false;

        this.$emit('hasError', 'GENERIC_ERROR');
      });
    },
    sendStatusToFs(status) {
      if (!this.wasSentFsStatus) {
        this.wasSentFsStatus = true;
        this.$fullStory.event('paymentDone', {
          isSuccessful_bool: status,
          cicle_int: this.limitRequest
        });
      }
    },
    sendErrorToFs(err) {
      if (err.response) {
        this.$fullStory.event('catchError', {
          status_int: err.response.status,
          cicle_int: this.limitRequest
        });
      } else {
        this.$fullStory.event('catchError', {
          status_msg_str: err.message || '0',
          cicle_int: this.limitRequest
        });
      }
    },
    sendOrderStatusToFs(orderStatus) {
      this.$fullStory.event('catchError', {
        status_str: orderStatus,
        cicle_int: this.limitRequest
      });
    }
  },
  render() {
    return this.$scopedSlots.default({
      paymentInfo: this.paymentInfo,
      isLoading: this.isLoading
    });
  }
};
</script>

<style scoped>

</style>
